var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHash(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 84,
    height: 89,
    viewBox: "0 0 84 89",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2186_1491)"
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.72,
    d: "M43.7391 51.1085L43.8816 41.9374L36.4785 41.8199L36.3359 50.9911L43.7391 51.1085ZM20.4437 66.1006L11.3481 65.9569L11.5868 50.6009L20.6824 50.7447L20.8249 41.5735L11.7294 41.4298L11.9681 26.0738L21.0636 26.2176L21.3125 10.2217L36.9649 10.4692L36.716 26.4651L44.1192 26.5826L44.368 10.5867L60.0205 10.8342L59.7716 26.8301L68.8671 26.9738L68.6284 42.3298L59.5329 42.1861L59.3904 51.3572L68.4859 51.5009L68.2472 66.8569L59.1517 66.7132L58.9322 80.7893L43.2797 80.5418L43.4992 66.4656L36.0961 66.3482L35.8766 80.4243L20.2242 80.1767L20.4437 66.1006Z",
    fill: "#8D00E8",
    stroke: "#020302",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.78,
    d: "M46.531 49.0987L46.6736 39.9275L39.2705 39.81L39.1279 48.9812L46.531 49.0987ZM23.2357 64.0907L14.1401 63.947L14.3788 48.5911L23.4744 48.7348L23.6169 39.5636L14.5214 39.4199L14.7601 24.064L23.8556 24.2077L24.1045 8.21179L39.7569 8.45932L39.508 24.4552L46.9112 24.5727L47.16 8.57681L62.8125 8.82434L62.5636 24.8202L71.6591 24.964L71.4204 40.3199L62.3249 40.1762L62.1823 49.3473L71.2779 49.4911L71.0392 64.847L61.9436 64.7033L61.7242 78.7794L46.0717 78.5319L46.2912 64.4558L38.8881 64.3383L38.6686 78.4144L23.0162 78.1668L23.2357 64.0907Z",
    fill: "#8D00E8",
    stroke: "#020302",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.83,
    d: "M49.3245 47.09L49.467 37.9189L42.0639 37.8014L41.9214 46.9725L49.3245 47.09ZM26.0291 62.0821L16.9336 61.9383L17.1723 46.5824L26.2678 46.7261L26.4104 37.555L17.3148 37.4112L17.5535 22.0553L26.6491 22.199L26.8979 6.20312L42.5504 6.45065L42.3015 22.4465L49.7046 22.564L49.9535 6.56815L65.6059 6.81568L65.357 22.8116L74.4526 22.9553L74.2139 38.3112L65.1183 38.1675L64.9758 47.3387L74.0713 47.4824L73.8326 62.8383L64.7371 62.6946L64.5176 76.7707L48.8652 76.5232L49.0847 62.4471L41.6815 62.3296L41.4621 76.4057L25.8096 76.1582L26.0291 62.0821Z",
    fill: "#A439B4",
    stroke: "#020302",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.89,
    d: "M52.1165 45.08L52.259 35.9088L44.8559 35.7913L44.7134 44.9625L52.1165 45.08ZM28.8211 60.0721L19.7256 59.9283L19.9643 44.5724L29.0598 44.7161L29.2023 35.545L20.1068 35.4012L20.3455 20.0453L29.441 20.189L29.6899 4.19312L45.3424 4.44065L45.0935 20.4365L52.4966 20.554L52.7455 4.55814L68.3979 4.80567L68.149 20.8016L77.2446 20.9453L77.0059 36.3012L67.9103 36.1575L67.7678 45.3287L76.8633 45.4724L76.6246 60.8283L67.5291 60.6846L67.3096 74.7607L51.6572 74.5132L51.8767 60.4371L44.4735 60.3196L44.2541 74.3957L28.6016 74.1482L28.8211 60.0721Z",
    fill: "#DCC634",
    stroke: "#020302",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.94,
    d: "M54.9095 43.0713L55.052 33.9002L47.6489 33.7827L47.5063 42.9538L54.9095 43.0713ZM31.6141 58.0634L22.5186 57.9197L22.7573 42.5637L31.8528 42.7074L31.9953 33.5363L22.8998 33.3926L23.1385 18.0366L32.234 18.1803L32.4829 2.18445L48.1353 2.43198L47.8865 18.4279L55.2896 18.5454L55.5385 2.54947L71.1909 2.797L70.942 18.7929L80.0375 18.9366L79.7988 34.2926L70.7033 34.1488L70.5608 43.32L79.6563 43.4637L79.4176 58.8197L70.3221 58.6759L70.1026 72.752L54.4502 72.5045L54.6696 58.4284L47.2665 58.3109L47.047 72.387L31.3946 72.1395L31.6141 58.0634Z",
    fill: "#E8E31A",
    stroke: "#020302",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.7024 41.0625L57.845 31.8913L50.4419 31.7739L50.2993 40.945L57.7024 41.0625ZM34.407 56.0546L25.3115 55.9108L25.5502 40.5549L34.6457 40.6986L34.7883 31.5275L25.6928 31.3837L25.9315 16.0278L35.027 16.1715L35.2759 0.17334L50.9283 0.420869L50.6794 16.4168L58.0825 16.5342L58.3314 0.53836L73.9839 0.78589L73.735 16.7818L82.8305 16.9255L82.5918 32.2815L73.4963 32.1377L73.3537 41.3089L82.4493 41.4526L82.2105 56.8086L73.115 56.6648L72.8956 70.7409L57.2431 70.4934L57.4626 56.4173L50.0595 56.2998L49.84 70.3759L34.1876 70.1284L34.407 56.0523V56.0546Z",
    fill: "#F3FF00",
    stroke: "#020302",
    strokeMiterlimit: 10
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2186_1491"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 83,
    height: 89,
    fill: "white",
    transform: "translate(0.00488281)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHash);
export default __webpack_public_path__ + "static/media/hash.678ba3cebf07a32a01b647bdcac10e7f.svg";
export { ForwardRef as ReactComponent };